var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "footer" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.config.name))]),
      _vm._v(" "),
      _c("p", { staticClass: "address_tel_fax" }, [
        _c("span", [_vm._v("地址：" + _vm._s(_vm.config.address))]),
        _vm._v(" "),
        _c("span", [_vm._v("Tel：" + _vm._s(_vm.config.phone))]),
        _vm._v(" "),
        _c("span", [_vm._v("Fax：" + _vm._s(_vm.config.tel))])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "email_wx" }, [
        _c("span", [_vm._v("邮箱：" + _vm._s(_vm.config.email))]),
        _vm._v(" "),
        _c("span", [_vm._v("公司微信号：" + _vm._s(_vm.config.wechat))])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "copy" }, [
        _vm._v(
          "Copyright © 2020 - 2022 " +
            _vm._s(_vm.config.keepOnRecordIcp) +
            " " +
            _vm._s(_vm.config.name)
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo_white.png"), alt: "logo图" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 